// extracted by mini-css-extract-plugin
export default {"topButton":"_1mbdfi6","bottomButton":"_h54o3q"};